import { useEffect, useState } from "react";

import {
    Box,
    Container,
    Typography,
    Button,
    Grid,
    Paper,
    Stack,
} from "@mui/material";

import AddRoundedIcon from "@mui/icons-material/AddRounded";
import ViewCarouselRoundedIcon from "@mui/icons-material/ViewCarouselRounded";

import { useBannerComunidad } from "../../hooks/UseBanner";

import StatusModal from "../../utils/StatusModal";

import BannerLista from "../../components/Admin/Banner/BannerLista";
import CrearBanner from "../../components/Admin/Banner/CrearBanner";
import EditarBanner from "../../components/Admin/Banner/EditarBanner";
import ConfirmarEliminar from "../../components/Admin/Banner/ConfirmarEliminar";


export const Banner = () => {

    const {
        banners,
        loading,
        cargarBanners,
        crearBanner,
        editarBanner,
        eliminarBanner,
    } = useBannerComunidad();


    /*
    |--------------------------------------------------------------------------
    | ESTADOS
    |--------------------------------------------------------------------------
    */

    const [openCrear, setOpenCrear] = useState(false);

    const [openEditar, setOpenEditar] = useState(false);

    const [openEliminar, setOpenEliminar] = useState(false);

    const [bannerSeleccionado, setBannerSeleccionado] = useState(null);
  
     const [modo, setModo] = useState("lista");

    /*
    |--------------------------------------------------------------------------
    | STATUS MODAL
    |--------------------------------------------------------------------------
    */

     const [statusModal, setStatusModal] = useState({
        open: false,
        status: "loading",
        title: "",
        message: "",
    });
    
    const mostrarModal = ({
        status,
        title,
        message,
    }) => {
        setStatusModal({
            open: true,
            status,
            title,
            message,
        });
    };
    
    const cerrarModal = () => {
        setStatusModal((prev) => ({
            ...prev,
            open: false,
        }));
    };


    /*
    |--------------------------------------------------------------------------
    | CARGAR BANNERS
    |--------------------------------------------------------------------------
    */

    useEffect(() => {

        cargarBanners();

    }, []);


  

    /*
    |--------------------------------------------------------------------------
    | CREAR
    |--------------------------------------------------------------------------
    */

    const handleCrear = async (formData) => {
   mostrarModal({
        status: "loading",
        title: "Creando Banner",
        message: "Estamos guardando la Banner. Por favor espera...",
    });
        try {

            await crearBanner(formData);

            setOpenCrear(false);

            await cargarBanners();

           setTimeout(() => {

            cerrarModal();

        }, 1800);

     mostrarModal({
            status: "success",
            title: "¡banner creada!",
            message: "La banner se ha creado correctamente.",
        });

        } catch (error) {

            console.error(error);

             mostrarModal({
            status: "error",
            title: "No se pudo crear la noticia",
            message:
                error?.response?.data?.message ||
                "Ocurrió un problema al intentar crear la noticia.",
        });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | ABRIR EDITAR
    |--------------------------------------------------------------------------
    */

    const handleAbrirEditar = (banner) => {

        setBannerSeleccionado(banner);

        setOpenEditar(true);

    };


    /*
    |--------------------------------------------------------------------------
    | EDITAR
    |--------------------------------------------------------------------------
    */

    const handleEditar = async (
        id,
        formData
    ) => {

         mostrarModal({
        status: "loading",
        title: "Actualizando noticia",
        message: "Estamos guardando los cambios. Por favor espera...",
    });
        try {

            await editarBanner(
                id,
                formData
            );

            setOpenEditar(false);

            setBannerSeleccionado(null);

            await cargarBanners();

             mostrarModal({
                status: "success",
                title: "¡Noticia actualizada!",
                message: "Los cambios se guardaron correctamente.",
            });

            setTimeout(() => {
                setModo("lista");
                setBannerSeleccionado(null);
                cerrarModal();
            }, 1800);

        } catch (error) {

            console.error(error);

             mostrarModal({
            status: "error",
            title: "Error al actualizar",
            message:
                error?.response?.data?.message ||
                "Ocurrió un problema al actualizar la noticia.",
        });

        }

    };


    /*
    |--------------------------------------------------------------------------
    | ABRIR ELIMINAR
    |--------------------------------------------------------------------------
    */

    const handleAbrirEliminar = (banner) => {

        setBannerSeleccionado(banner);

        setOpenEliminar(true);

    };


    /*
    |--------------------------------------------------------------------------
    | ELIMINAR
    |--------------------------------------------------------------------------
    */

    const handleEliminar = async () => {

        if (!bannerSeleccionado) return;
        mostrarModal({
        status: "loading",
        title: "Eliminando noticia",
        message: "Estamos eliminando la noticia. Por favor espera...",
    });

        try {

            await eliminarBanner(
                bannerSeleccionado
            );

            setOpenEliminar(false);

            setBannerSeleccionado(null);

            await cargarBanners();

              mostrarModal({
            status: "success",
            title: "¡Noticia eliminada!",
            message: "La noticia se eliminó correctamente.",
        });

        setTimeout(() => {
            setModo("lista");
            setBannerSeleccionado(null);
            cerrarModal();
        }, 1800);

        } catch (error) {

            console.error(error);

           mostrarModal({
            status: "error",
            title: "Error al eliminar",
            message:
                error?.response?.data?.message ||
                error?.message ||
                "Ocurrió un problema al eliminar la noticia.",
        });

        }

    };


    
    /*
    |--------------------------------------------------------------------------
    | ESTADÍSTICAS
    |--------------------------------------------------------------------------
    */

    const totalBanners = banners?.length || 0;

    const bannersConImagen = banners?.filter(
        (banner) => banner.imagen
    ).length || 0;

    const posiciones = banners?.filter(
        (banner) =>
            banner.posicion !== null &&
            banner.posicion !== undefined
    ).length || 0;


    return (

        <Box
            sx={{
                minHeight: "100vh",
                background: "#f6f8fc",
                py: 4,
            }}
        >

            <Container maxWidth="xl">


                {/* ================================================= */}
                {/* HEADER */}
                {/* ================================================= */}

                <Box
                    sx={{
                        mb: 4,

                        display: "flex",

                        justifyContent:
                            "space-between",

                        alignItems: "center",

                        gap: 3,

                        flexWrap: "wrap",
                    }}
                >

                    <Stack
                        direction="row"
                        spacing={2}
                        alignItems="center"
                    >

                        <Box
                            sx={{
                                width: 54,
                                height: 54,

                                borderRadius: "12px",

                                background: "#eaf0f7",

                                display: "flex",

                                alignItems: "center",

                                justifyContent: "center",
                            }}
                        >

                            <ViewCarouselRoundedIcon
                                sx={{
                                    color: "#12213F",
                                    fontSize: 28,
                                }}
                            />

                        </Box>


                        <Box>

                            <Typography
                                sx={{
                                    color: "#12213F",

                                    fontWeight: 800,

                                    fontSize: {
                                        xs: "1.7rem",
                                        md: "2rem",
                                    },

                                    fontFamily: "Archivo",

                                    lineHeight: 1.1,
                                }}
                            >
                                Banners
                            </Typography>


                            <Typography
                                sx={{
                                    mt: .5,

                                    color: "#687083",

                                    fontSize: ".95rem",
                                }}
                            >
                                Administra los banners de la
                                comunidad del Colegio Antilen.
                            </Typography>

                        </Box>

                    </Stack>


                    {/* BOTÓN CREAR */}

                    <Button
                        variant="contained"

                        startIcon={
                            <AddRoundedIcon />
                        }

                        onClick={() =>
                            setOpenCrear(true)
                        }

                        sx={{
                            background: "#12213F",

                            color: "#fff",

                            borderRadius: "9px",

                            px: 2.5,

                            py: 1.2,

                            fontWeight: 700,

                            textTransform: "none",

                            boxShadow:
                                "0 4px 10px rgba(18,33,63,.15)",

                            "&:hover": {
                                background: "#1c3154",
                            },
                        }}
                    >
                        Crear banner
                    </Button>

                </Box>


                {/* ================================================= */}
                {/* ESTADÍSTICAS */}
                {/* ================================================= */}

                <Grid
                    container
                    spacing={2}
                    sx={{ mb: 4 }}
                >

                    {/* TOTAL */}

                    <Grid
                        item
                        xs={12}
                        md={4}
                    >

                        <Paper
                            elevation={0}
                            sx={{
                                p: 2.5,

                                borderRadius: "14px",

                                border:
                                    "1px solid #e1e6ee",

                                background: "#fff",
                            }}
                        >

                            <Typography
                                sx={{
                                    color: "#687083",

                                    fontSize: 12,

                                    fontWeight: 700,

                                    textTransform:
                                        "uppercase",
                                }}
                            >
                                Total banners
                            </Typography>


                            <Typography
                                sx={{
                                    mt: 1,

                                    color: "#12213F",

                                    fontSize: 28,

                                    fontWeight: 800,
                                }}
                            >
                                {totalBanners}
                            </Typography>

                        </Paper>

                    </Grid>


                    {/* CON IMAGEN */}

                    <Grid
                        item
                        xs={12}
                        md={4}
                    >

                        <Paper
                            elevation={0}
                            sx={{
                                p: 2.5,

                                borderRadius: "14px",

                                border:
                                    "1px solid #e1e6ee",

                                background: "#fff",
                            }}
                        >

                            <Typography
                                sx={{
                                    color: "#687083",

                                    fontSize: 12,

                                    fontWeight: 700,

                                    textTransform:
                                        "uppercase",
                                }}
                            >
                                Con imagen
                            </Typography>


                            <Typography
                                sx={{
                                    mt: 1,

                                    color: "#159447",

                                    fontSize: 28,

                                    fontWeight: 800,
                                }}
                            >
                                {bannersConImagen}
                            </Typography>

                        </Paper>

                    </Grid>


                    {/* POSICIONES */}

                    <Grid
                        item
                        xs={12}
                        md={4}
                    >

                        <Paper
                            elevation={0}
                            sx={{
                                p: 2.5,

                                borderRadius: "14px",

                                border:
                                    "1px solid #e1e6ee",

                                background: "#fff",
                            }}
                        >

                            <Typography
                                sx={{
                                    color: "#687083",

                                    fontSize: 12,

                                    fontWeight: 700,

                                    textTransform:
                                        "uppercase",
                                }}
                            >
                                Posiciones configuradas
                            </Typography>


                            <Typography
                                sx={{
                                    mt: 1,

                                    color: "#c27b16",

                                    fontSize: 28,

                                    fontWeight: 800,
                                }}
                            >
                                {posiciones}
                            </Typography>

                        </Paper>

                    </Grid>

                </Grid>


                {/* ================================================= */}
                {/* LISTADO DE BANNERS */}
                {/* ================================================= */}

                <BannerLista
                    banners={banners}
                    loading={loading}

                    onEditar={handleAbrirEditar}

                    onEliminar={handleAbrirEliminar}
                />


                {/* ================================================= */}
                {/* CREAR */}
                {/* ================================================= */}

                <CrearBanner
                    open={openCrear}

                    onClose={() =>
                        setOpenCrear(false)
                    }

                    onSubmit={handleCrear}

                    loading={loading}
                />


                {/* ================================================= */}
                {/* EDITAR */}
                {/* ================================================= */}

                <EditarBanner
                    open={openEditar}

                    banner={bannerSeleccionado}

                    onClose={() => {
                        setOpenEditar(false);
                        setBannerSeleccionado(null);
                    }}

                    onSubmit={handleEditar}

                    loading={loading}
                />


                {/* ================================================= */}
                {/* CONFIRMAR ELIMINAR */}
                {/* ================================================= */}

                <ConfirmarEliminar
                    open={openEliminar}

                    banner={bannerSeleccionado}

                    onClose={() => {
                        setOpenEliminar(false);
                        setBannerSeleccionado(null);
                    }}

                    onConfirm={handleEliminar}

                    loading={loading}
                />


                {/* ================================================= */}
                {/* STATUS MODAL */}
                {/* ================================================= */}

                <StatusModal
                open={statusModal.open}
                status={statusModal.status}
                title={statusModal.title}
                message={statusModal.message}
                onClose={cerrarModal}
            />

            </Container>

        </Box>

    );
};